
<template lang="pug">

    tr(v-bind:class="{ declined: isDeclined }")

        //- Lieferant
        td.field
            | {{ supplierModel.name }}
            span.ui.tiny.red.label(v-if='isDeclined') Abgelehnt

        //- HK
        td.field
            input(type='number' v-model.number="production" v-bind:disabled='isDeclined')

        //- DB HK
        td.field
            input(type='number' v-model.number="contributionMarginOfProduction" v-bind:disabled='isDeclined')

        //- VK Produktion
        td.field
            input(type='number' v-model.number="productionSellingPrice" v-bind:disabled='isDeclined')

        //- Versand
        td.field
            input(type='number' v-model.number="shipping" v-bind:disabled='isDeclined')

        //- DB Versand
        td.field
            input(type='number' v-model.number="contributionMarginOfShipping" v-bind:disabled='isDeclined')

        //- VK Versand
        td.field
            input(type='number' v-model.number="shippingSellingPrice" v-bind:disabled='isDeclined')

        //- Zusatzkosten
        td.field
            input(type='number' v-bind:value="additionCostsSum" v-on:focus="showAdditionalCostsModal()" readonly v-bind:disabled='isDeclined')

            // Zusatzkosten bearbeiten
            modal(ref='modal')
                span(slot='header') Zusatzkosten
                additional-costs-form(
                    ref='additionalCostsForm'
                    slot='content'
                    v-bind:additional-cost-models='additionalCostModels'
                    v-bind:price-model='valueModel'
                )
                action-row(
                    slot='footer'
                    saveLabel='Speichern'
                    v-on:cancel="cancelAdditionalCosts()"
                    v-on:save="persistAdditionalCosts()"
                )

        //- Verkaufspreis
        td.field {{ sellingPrice }}

        //- DB Gesamt
        td.field {{ contributionMargin }}

        //- Tausenderpreis
        td.field {{ costPerThousand }}

        //- Angebotsgültigkeit Lieferant
        td.field
            date-field(v-model="validUntilBySupplier" v-bind:disabled='isDeclined')
            field-error(v-bind:$v='$v.validUntilBySupplier' validator='required' v-bind:hideMessage="true")

        //- Angebotsgültigkeit DuW
        td.field
            date-field(v-model="validUntilByZmuek" v-bind:disabled='isDeclined')
            field-error(v-bind:$v='$v.validUntilByZmuek' validator='required' v-bind:hideMessage="true")

</template>

<script>
    import * as R from 'ramda'
    import capitalize from 'lodash/capitalize'
    import roundTo from 'round-to'
    import { requiredIf } from 'vuelidate/lib/validators'
    import { to_currency } from '@/utils/currency'
    import ActionRow from '@/components/form/ActionRow'
    import AdditionalCostsForm from './price-table-form/AdditionalCostsForm'
    import DateField from '@/components/form/DateField'
    import FieldError from '@/components/form/FieldError'
    import Modal from '@/components/app/Modal'
    import { contribution_margin_sum, per_thousand_sum, total_selling_sum } from '@/utils/price'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { ActionRow, AdditionalCostsForm, DateField, FieldError, Modal },

        computed: {

            additionCostsSum() {
                return R.compose(

                    // Beträge summieren
                    // > [ 1, 3 ]
                    // < 4
                    R.sum,

                    // Betrag auslesen
                    // > [ { amount: 1, ... }, { amount: 3, ... } ]
                    // < [ 1, 3 ]
                    R.map(R.prop('amount'))

                )(this.additionalCostModels)
            },

            contributionMarginOfProduction: {
                get() { return this.valueModel.contributionMarginOfProduction || 0 },
                set(value) { this.valueModel = R.assoc('contributionMarginOfProduction', value, this.valueModel) }
            },

            contributionMarginOfShipping: {
                get() { return this.valueModel.contributionMarginOfShipping || 0 },
                set(value) { this.valueModel = R.assoc('contributionMarginOfShipping', value, this.valueModel) }
            },

            contributionMargin() {
                return R.compose(

                    // Zu Währung umwandeln
                    // > 123.2211
                    // < 123,22 €
                    to_currency('€'),

                    // > { production: 20, shipping: 4, ... }
                    // < 123.2211
                    contribution_margin_sum

                )(this.valueModel)
            },

            costPerThousand() {
                return R.compose(

                    // Zu Währung umwandeln
                    // > 123.2211
                    // < 123,22 €
                    to_currency('€'),

                    // 1000er-Preis berechnen
                    // > { production: 20, shipping: 4, ... }
                    // < 123.2211
                    per_thousand_sum

                )(this.valueModel)
            },

            isDeclined() {
                return this.offerModel.status === 'DECLINED'
            },

            printing: {
                get() { return this.valueModel.printing },
                set(value) { this.valueModel = R.assoc('printing', value, this.valueModel) }
            },

            production: {
                get() { return this.valueModel.production || 0 },
                set(value) { this.valueModel = R.assoc('production', value, this.valueModel) }
            },

            productionSellingPrice: {
                get() { return this.getSellingPriceOf('production') },
                set(value) { this.setSellingPriceOf('production', value) },
            },

            sellingPrice() {
                return R.compose(

                    // Zu Währung umwandeln
                    // > 123.2211
                    // < 123,22 €
                    to_currency('€'),

                    // > { production: 20, shipping: 4, ... }
                    // < 123.2211
                    total_selling_sum

                )(this.valueModel)
            },

            shipping: {
                get() { return this.valueModel.shipping || 0 },
                set(value) { this.valueModel = R.assoc('shipping', value, this.valueModel) }
            },

            shippingSellingPrice: {
                get() { return this.getSellingPriceOf('shipping') },
                set(value) { this.setSellingPriceOf('shipping', value) }
            },

            validUntilBySupplier: {
                get() { return this.offerModel.validUntilBySupplier },
                set(value) { this.updateOfferModel(value, 'validUntilBySupplier') }
            },

            validUntilByZmuek: {
                get() { return this.offerModel.validUntilByZmuek },
                set(value) { this.updateOfferModel(value, 'validUntilByZmuek') }
            },

        },

        data() {
            return {
                valueModel: R.clone(this.priceModel)
            }
        },

        created() {
            if (R.isNil(this.validUntilByZmuek) && !R.isNil(this.validUntilBySupplier)) {
                this.validUntilByZmuek = this.validUntilBySupplier
            }
        },

        methods: {

            cancelAdditionalCosts() {
                this.$refs.modal.close()
            },

            getSellingPriceOf(property) {
                return R.compose(
                    // NaN abfangen (z.B. wenn HK oder DB noch nicht gesetzt)
                    value => isNaN(value) ? 0 : value,

                    // Verkauspreis runden
                    R.curry(roundTo)(R.__, 2),

                    // Verkaufspreis ermitteln
                    margin => this[property] * ( margin / 100 + 1 ),

                    // Deckungsbetrag lesen
                    R.prop(R.__, this),

                    // Property für Deckungsbetrag erstellen
                    property => `contributionMarginOf${capitalize(property)}`

                )(property)
            },

            async persist() {
                const id = this.valueModel.id
                const patch = this.valueModel
                return await this.$store.dispatch('prices/patch', { id, patch })
            },

            async persistAdditionalCosts() {
                // Pruefen ob Formular valide ist
                if (await this.$refs.additionalCostsForm.validate() === false) {
                    return
                }

                try {
                    // Zusatzkosten speichern
                    await this.$refs.additionalCostsForm.persist()

                    // Erfolgsmeldung anzeigen
                    this.$growl.success('Zusatzkosten wurden gespeichert')

                    // Modal closen
                    this.$refs.modal.close()

                } catch (e) {
                    // Fehlermeldung anzeigen
                    this.$growl.fatal('Fehler beim Speichern von Zusatzkosten aufgetreten', e)
                }
            },

            setSellingPriceOf(property, value) {
                // Property fuer Deckungsbetrag ermitteln
                const marginProperty = `contributionMarginOf${capitalize(property)}`

                this.valueModel = R.compose(

                    // Deckungsbetrag aktualisieren
                    margin => R.assoc(marginProperty, margin, this.valueModel),

                    // Deckungsbetrag runden
                    R.curry(roundTo)(R.__, 4),

                    // Deckungsbetrag ermitteln
                    sum => (value / sum - 1) * 100,

                    // Wert lesen
                    R.prop(R.__, this)

                )(property)
            },

            showAdditionalCostsModal() {
                this.$refs.modal.show()
            },

            updateOfferModel(value, property) {
                this.$emit('input-offer', R.assoc(property, value, this.offerModel))
            },

            async validate() {
                this.$v.$touch()
                return this.$v.$invalid === false
            }

        },

        props: {

            additionalCostModels: {
                type: Array,
                default: R.always([])
            },

            offerModel: {
                type: Object,
                required: true
            },

            priceModel: {
                type: Object,
                required: true
            },

            supplierModel: {
                type: Object,
                required: true
            },

        },

        validations: {

            validUntilBySupplier: {
                required: requiredIf(vm => vm.sellingPrice > 0)
            },

            validUntilByZmuek: {
                required: requiredIf(vm => vm.sellingPrice > 0)
            },

        },

        watch: {

            priceModel(model) {
                this.valueModel = R.clone(model)
            },

            validUntilBySupplier(value) {
                // Wenn noch keine Angebotsgueltigkeit fuer "Angebotsgultigkeit von DuW" angeben wurden, die
                // Angebotsgueltigkeit des Lieferanten uebernehmen
                if (!R.isNil(value) && R.isNil(this.validUntilByZmuek)) {
                    this.validUntilByZmuek = value
                }
            }

        }

    }

</script>

<style scoped>

    tr.declined {
        opacity: 0.5;
    }

    tr.declined .ui.label {
        opacity: 1;
        margin-left: 6px;
    }

</style>
